// namespace Pacem {
export class Keys {
    static #seed;
    static uniqueId() {
        let seed = Keys.#seed || Date.now();
        return Keys.#seed = ++seed;
    }
    static uniqueCode() {
        const newid = Keys.uniqueId();
        return newid.toBase62();
    }
    static randomString(length) {
        let retval = '';
        do {
            retval += (Math.random() * 62).toBase62();
        } while (retval.length < length);
        return retval;
    }
}
// }
